import novo from '../../img/novo.jpg'
import rodape from '../../img/rodape.jpg'
// import AWS from 'aws-sdk';
// import {sendFile} from '../whatsApp/whatsapp'






export default function PrintReports(infos, nomeMed, nomePac, titlePag ,date,crmMed,propsCab,propsRod,assinatura){
    
    // Função para verificar se assinatura está vazia
    const isSignatureEmpty = (signature) => {
        if (!signature) return true;
        if (signature === 'null' || signature === null) return true;
        if (typeof signature !== 'string') return true;
        
        // Verifica se é uma assinatura vazia (canvas transparente)
        const emptyCanvas = document.createElement('canvas');
        emptyCanvas.width = 320;
        emptyCanvas.height = 200;
        const emptyDataURL = emptyCanvas.toDataURL();
        
        // Verifica se é igual ao canvas vazio ou muito pequena
        if (signature === emptyDataURL) return true;
        if (signature.length < 1000) return true;
        
        // Verifica se contém apenas dados de canvas transparente
        if (signature.includes('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAADICAYAAACTrQdGAAAA')) {
            // Esta é a assinatura de um canvas vazio de 320x200
            return true;
        }
        
        return false;
    };
    
    const hasValidSignature = !isSignatureEmpty(assinatura);
    const pdfMake = require('pdfmake/build/pdfmake');
    const pdfFonts = require('pdfmake/build/vfs_fonts');
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    // pdfMake.addVirtualFileSystem(pdfFonts);

    // pdfMake.fonts = { Arial: {  normal:   'fonts/Arial.ttf', 
    //                             bold: 'fonts/Arial-Bold.ttf', 
    //                             italics: 'fonts/Arial-Italic.ttf', 
    //                             bolditalics: 'fonts/Arial-BoldItalic.ttf' },

    //                 Roboto: {  normal:   'fonts/Roboto-Regular.ttf', 
    //                         bold: 'fonts/RobotoBold.ttf', 
    //                         italics: 'fonts/RobotoItalic.ttf', 
    //                         bolditalics: 'fonts/RobotoBoldItalic.ttf' } 
    //                 };
    var snow;
    var snow2;
    // console.log(pdfMake.fonts)

    
    // CRIA UM VALOR RAMDOMICO PARA O ARQUIVO NUNCA ser O MESMO E O CACHE NAO ACONTECER
   var nocache = new Date(); 
    // VERIFICA SE O MEDICO TEM CABECALHO OU RODAPE, SE SIM ASSOCIA A VARIAVEL QUE PRINTA NO PDF
    // Função para converter mm para pontos baseada em medição real (70mm config = 16mm real)
    const mmToPoints = (mm) => Math.round(mm * 4.4);
    

    
    // Detecta se é URL de imagem ou altura em mm
    const isImageUrl = (value) => value && typeof value === 'string' && (value.includes('.jpg') || value.includes('.jpeg') || value.includes('.png'));
    const isHeightValue = (value) => value && typeof value === 'string' && value.includes('mm');
    
    let cabecalhoHeight = 78; // altura padrão
    let rodapeHeight = 60;    // altura padrão
    
    // Inicializa com valores padrão
    snow = novo;
    snow2 = rodape;
    
    if (propsCab && propsCab != 0) {
        if (isImageUrl(propsCab)) {
            snow = 'https://imgsti.s3.sa-east-1.amazonaws.com/'+ 'cab+' + nomeMed.substring(0,10).replace(' ','+').toLowerCase() + '.jpg?' + nocache.getTime();
        } else if (isHeightValue(propsCab)) {
            const mmValue = parseInt(propsCab.replace('mm', ''));
            cabecalhoHeight = mmToPoints(mmValue);
        }
    }
    
    if (propsRod && propsRod != 0) {
        if (isImageUrl(propsRod)) {
            snow2 = 'https://imgsti.s3.sa-east-1.amazonaws.com/'+ 'rod+' + nomeMed.substring(0,10).replace(' ','+').toLowerCase() + '.jpg?' + nocache.getTime();
        } else if (isHeightValue(propsRod)) {
            const mmValue = parseInt(propsRod.replace('mm', ''));
            rodapeHeight = mmToPoints(mmValue);
        }
    }
//    snow    = novo;
//    snow2   = rodape;
    const globalStyle = {// Define a fonte
        fontSize: 10, // Define o tamanho da fonte padrão
        color: 'black', // Define a cor do texto padrão
    };

    // Cabeçalho sem bordas vermelhas no receituário
    const title = [
        {image: 'snowIMG', width: 530, height: cabecalhoHeight, alignment: 'center', margin: [0, 10]}
    ]
    
  
    
    const reportTitle = [
        {
          text: titlePag,
          style: 'header'
        },
    ];

    const infoPacienteData = [
        {
            columns: [
                {text: `Paciente: ${nomePac}`, style: 'subheader', width: '*'},
                {text: `Data: ${date}`, style: 'subheaderRight', width: 'auto'}
            ],
            margin: titlePag !== 'Atestado' ? (isHeightValue(propsCab) ? [0, 10] : [0, 10]) : (isHeightValue(propsCab) ? [0, 15] : [0, 50])
        }
    ];

    const assina = [
        
        {   
            image: assinatura,
            width: 75, height: 75,
            alignment: 'center',
            margin: [0, 0, 0, -20] // ALTURA DO RODAPÉ
            
        }
    ]

    const infoMed = [
        {text: `${nomeMed}`, style: 'header2'}
 
    ];
    const infoCrmMed = [
        {text: `${crmMed}`, style: 'headerCRM'} // AQUI É A VARIAVEL QUE VAI APARECER E ONDE
    ]
  
    // const details = [
    //     {
    //         text: infos
    //         // content: infos
    //     }
    // ];
  
    function Rodape(currentPage, pageCount){
        return [
            {                
                image: 'snowIMG2',
                width: 530, 
                height: rodapeHeight,
                alignment: 'center', 
                margin: [0, 0, 0, 10]
            }
        ]
    }
  
  try {
    const docDefinitions = {
      info: {
          title: 'Receituario '+ (nomePac || 'Paciente'),
      },
      pageSize: 'A4',
      pageMargins: [30, Math.max(50, cabecalhoHeight + 20), 30, Math.max(50, rodapeHeight + 20)],
      header: title || [],
      content: [
          ...(titlePag !== 'Atestado' ? reportTitle : []), 
          infoPacienteData, 
          ...(Array.isArray(infos) ? infos : [infos || {text: ''}]), 
          ...(hasValidSignature ? [{
              image: 'assina',
              width: 75, 
              height: 75,
              alignment: 'center',
              margin: [0, 0, 0, -20]
          }] : []),
          ...infoMed, 
          ...infoCrmMed
      ],
      images: {
          snowIMG: snow || novo,
          snowIMG2: snow2 || rodape,
          assina: assinatura || novo
      },
      footer: Rodape,
      defaultStyle: globalStyle,
      styles: {
          header: {
              fontSize: 17.5,
              margin: isHeightValue(propsCab) ? [0, 5, 0, 0] : [0, 38, 0, 0],
              bold: true,
              alignment: 'center',
              width: '100%'
          },
          header2: {
              fontSize: 12,
              margin: [0, 30, 0, 0], 
              bold: true,
              alignment: 'center',
              width: '100%'
          },
          headerCRM: {
              fontSize: 10,
              margin: [0, 7, 0, 0], 
              bold: true,
              alignment: 'center',
              width: '100%'
          },        
          subheader: {
              fontSize: 12,
              alignment: 'left'
          },
          subheaderRight: {
              fontSize: 12,
              alignment: 'right'
          },
          tableHeader: {
              margin: [0, 5],
          }
      }
    }
    return docDefinitions;
  } catch (error) {
    return {
      content: [{text: 'Erro ao gerar PDF'}],
      images: {snowIMG: novo, snowIMG2: rodape},
      defaultStyle: globalStyle
    };
  }
}
  
